import { Chip, TableCell, TableRow } from '@mui/material';
import { type JobStep, JobStepStatus } from '@repo/api-gw-sdk';

import { dayjs, DATE_FORMAT, TIME_FORMAT } from '@/utils/dayjs';

const stepNameDisplayMap: Record<string, string> = {
  // GCP VM Backup steps
  CREATE_VM_SNAPSHOT: 'Create VM Snapshot',
  // DynamoDB Restore steps
  CREATE_DDB_TABLE: 'Create DynamoDB Table',
  WRITE_DDB_DATA: 'Write DynamoDB Data',
  RESTORE_DDB_CONFIG: 'Restore DynamoDB Config',
  RECREATE_DDB_GSIS: 'Recreate DynamoDB GSIs',
};

const stepStatusConfig: Record<
  JobStepStatus,
  {
    label: string;
    color: 'default' | 'primary' | 'success' | 'error' | 'warning';
  }
> = {
  [JobStepStatus.JOB_STEP_STATUS_UNSPECIFIED]: {
    label: 'Unknown',
    color: 'default',
  },
  [JobStepStatus.JOB_STEP_STATUS_PENDING]: {
    label: 'Pending',
    color: 'default',
  },
  [JobStepStatus.JOB_STEP_STATUS_RUNNING]: {
    label: 'Running',
    color: 'primary',
  },
  [JobStepStatus.JOB_STEP_STATUS_COMPLETED]: {
    label: 'Completed',
    color: 'success',
  },
  [JobStepStatus.JOB_STEP_STATUS_FAILED]: { label: 'Failed', color: 'error' },
};

const formatStepName = (stepName: string): string => {
  return stepNameDisplayMap[stepName] || stepName;
};

const formatDateTime = (date: Date | null | undefined): string => {
  if (!date) return '-';
  return `${dayjs.utc(date).format(DATE_FORMAT)} ${dayjs.utc(date).format(TIME_FORMAT)} UTC`;
};

const StepStatusChip = ({ status }: { status: JobStepStatus }) => {
  const config =
    stepStatusConfig[status] ||
    stepStatusConfig[JobStepStatus.JOB_STEP_STATUS_UNSPECIFIED];
  return (
    <Chip
      label={config.label}
      color={config.color}
      size='small'
      variant='outlined'
    />
  );
};

export const JobStepRow = ({ step }: { step: JobStep }) => {
  return (
    <TableRow>
      <TableCell>{formatStepName(step.stepName)}</TableCell>
      <TableCell>
        <StepStatusChip status={step.status} />
      </TableCell>
      <TableCell>{formatDateTime(step.startTime)}</TableCell>
      <TableCell>{formatDateTime(step.endTime)}</TableCell>
    </TableRow>
  );
};
